import React from 'react'

import './SMSPreview.css'

const SMSPreview = ({ state }) => (
  <div className="sms">{state.body}</div>
)

export default SMSPreview


// WEBPACK FOOTER //
// ./src/components/campaigns/previews/SMSPreview.js